import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class SnackbarFactory {
  constructor(
    private translate: TranslateService,
    private snackBar: MatSnackBar
  ) {}

  private duration_snackbar(text: string, pclass: string, duration: number) {
    text = text === null ? 'missing-text' : text;

    this.translate.get(text).subscribe((message: string) => {
      this.snackBar.open(message, '', { duration, panelClass: pclass });
    });
  }

  private button_snackbar_text(text: string, pclass: string) {
    text = text === null ? 'missing-text' : text;

    this.translate.get(text).subscribe((message: string) => {
      this.snackBar.open(message, 'ok', { panelClass: pclass });
    });
  }

  showDurationSnackbar(r: any) {
    if (r != null && r.status >= 400 && r.status < 500) {
      const txt = (r as HttpErrorResponse).error;

      if (typeof txt === 'string') {
        this.duration_snackbar(txt, 'error-snackbar', 3000);
      } else {
        this.duration_snackbar(txt.title, 'error-snackbar', 3000);
      }
    } else {
      this.duration_snackbar('success', 'success-snackbar', 2000);
    }
  }

  showButtonSnackbar(r: any) {
    if (r.status === 403) {
      this.button_snackbar_text('not-authorized', 'error-snackbar');
      return;
    }

    if (r.error) {
      this.button_snackbar_text(r.error, 'error-snackbar');
      return;
    }

    if (r.status >= 400 && r.status < 500) {
      this.button_snackbar_text(
        (r as HttpErrorResponse).message,
        'error-snackbar'
      );

      // const txt = (r as HttpErrorResponse).error;

      // if (typeof txt === 'string') {
      //   this.button_snackbar_text(txt, 'error-snackbar');
      // } else {
      //   this.button_snackbar_text(txt.title, 'error-snackbar');
      // }
    } else if (r.status <= 500) {
      this.button_snackbar_text(r.error, 'error-snackbar');
    } else {
      this.button_snackbar_text('success', 'success-snackbar');
    }
  }

  showButtonSnackbarWithText(status: number, text: string) {
    if (status >= 200 && status < 300) {
      this.button_snackbar_text(text, 'success-snackbar');
    } else if (status >= 400 && status < 500) {
      this.button_snackbar_text(text, 'error-snackbar');
    }
  }

  showButtonSnackbarWithTexts(status: number, texts: Array<string>) {
    let tmp = '';
    texts.forEach((element) => {
      tmp += `    ${element}   |`;
    });

    this.showButtonSnackbarWithText(status, tmp);
  }

  showErrorText(text: string) {
    this.snackBar.open(text, 'ok', { panelClass: 'error-snackbar' });
  }
}
